import React from 'react';
import useFlagsToStates from '../../../hooks/useFlagsToStates';
import {
  netSuiteSupplierOnboarding,
  salesforceSupplierOnboarding,
  variantServiceProductEndpointEnabled,
  variantServiceProductFiltersEnabled,
  showMSRPPrices,
  tempHideHasPricePricingFilterSupplierIds,
  uiProductsFeedsPage,
} from '../../../constants/featureFlag';
import { InitApp } from '../../../initApp';
import styles from './AppLoader.module.scss';
import { AppLoaderCymbioImage } from './AppLoaderCymbioImage';

export function AppLoader() {
  const finishedLoading = useFlagsToStates({
    features: [
      variantServiceProductFiltersEnabled,
      variantServiceProductEndpointEnabled,
      netSuiteSupplierOnboarding,
      salesforceSupplierOnboarding,
      showMSRPPrices,
      tempHideHasPricePricingFilterSupplierIds,
      uiProductsFeedsPage,
    ],
  });

  if (!finishedLoading) {
    return (
      <div className={styles.pageWrapper}>
        <div className={styles.container}>
          <div className={styles.image}>
            <AppLoaderCymbioImage />
          </div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return <InitApp />;
}
